<template>
    <flex-element :element-type="elementType" class="e-video f-relative" class-default-inline="f-h-24 f-w-40">
        <div @mouseenter="showSelector" @mouseleave="hideSelector">
            <aside
                class="e-video__selector"
                :class="selectorClass"
                @click="hideSelector"
            >
                Select Element
            </aside>

            <div
                ref="richTextContent"
                data-video-wrapper
                @dblclick="onEditHtml"
            />
        </div>
    </flex-element>
</template>

<script>
import { mapMutations } from 'vuex';

import baseAtom from '@/mixins/base-atom/base-atom-smart';
import { AVideo } from '@/data/data-models';
import listenOnRootMixin from '@/mixins/listen-on-root';
import { STATE_CLASSES } from '@/data/constants/classes';
import { SHOW_MODAL } from '@/store/types/mutation-types';

export default {
    name: 'a-video',

    mixins: [baseAtom, listenOnRootMixin],

    props: {
        displayName: {
            type: String,
            default: 'Inline Video',
        },

        richText: {
            type: String,
            default: '',
        },

        templateId: {
            type: String,
            default: '{4DCF91AE-CB0F-4C58-B0DF-1C8EF965D581}',
        },
    },

    data() {
        return {
            cssDisplay: 'block',
            isSelectorVisible: false,
            richTextNew: '',
        };
    },

    computed: {
        updatedElement() {
            return new AVideo({
                ...this.updatedBaseElement,
                richText: this.richTextNew,
            });
        },

        selectorClass() {
            return this.isSelectorVisible
                ? STATE_CLASSES.VISIBLE
                : STATE_CLASSES.HIDDEN;
        },
    },

    created() {
        this.listenOnRoot('flex::rich-text::save', this.onModalSave);
    },

    mounted() {
        this.setHtml();
    },

    methods: {
        ...mapMutations({
            showModal: SHOW_MODAL,
        }),

        setFieldValues() {
            this.richTextNew = this.richText;
        },

        setHtml() {
            this.$refs.richTextContent.innerHTML = this.richTextNew
                || (this.$slots.default ? this.$slots.default[0].text.trim() : '[Embed code here]');
        },

        onEditHtml() {
            const editorEl = this.$refs.richTextContent;

            this.showModal({
                componentTag: 'rich-text-modal',
                data: {
                    elementId: this.id,
                    html: editorEl.innerHTML,
                    rteType: 'htmlOnly',
                },
            });
        },

        onModalSave(id, html) {
            if (this.id !== id) return;

            this.$refs.richTextContent.innerHTML = html;
            this.richTextNew = html;
            this.setChangedData(true);
        },

        hideSelector() {
            this.isSelectorVisible = false;
        },

        showSelector() {
            if (this.selectedElements[0] !== this) {
                this.isSelectorVisible = true;
            }
        },
    },
};
</script>

<style lang="scss">
.e-video {
    iframe,
    object,
    embed {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    &__selector{
        background-color: var(--elementToolbar-backgroundColor);
        color: var(--elementToolbar-color);
        font-size: 13px;
        font-weight: 700;
        position: absolute;
        padding: 5px 10px;
        top: 0;
        left: 0;
        width: 100%;
        z-index:1000;
        display: none;

        &.#{ $is-visible } {
            display: block;
        }

        &:hover {
            cursor: pointer;
        }
    }
}
</style>
